import { IconButton, Snackbar } from "@mui/material";
import Copy from "@mui/icons-material/FileCopy";
import { useState } from "react";

interface CopyToClipboardProps {
  text: string; // The text to be copied
}

const CopyToClipboard = ({ text }: CopyToClipboardProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopyToClipboard = async () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Clipboard API is supported
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
      } catch (err) {
        console.error("Failed to copy text: ", err);
        fallbackCopyTextToClipboard(text);
      }
    } else {
      // Clipboard API is not supported, use fallback
      fallbackCopyTextToClipboard(text);
    }
  };

  const fallbackCopyTextToClipboard = (text: string) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed"; // Avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        setCopied(true);
      } else {
        console.error("Fallback copy failed");
      }
    } catch (err) {
      console.error("Fallback copy failed: ", err);
    }

    document.body.removeChild(textArea);
  };

  return (
    <>
      <IconButton
        title="Copy to Clipboard"
        size="small"
        onClick={handleCopyToClipboard}
      >
        <Copy
          sx={{
            fontSize: 24,
            opacity: 0.5,
            "&:hover": {
              opacity: 1,
            },
          }}
        />
      </IconButton>
      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        message="Copied to Clipboard!"
        sx={{ opacity: 0.8 }}
      />
    </>
  );
};

export default CopyToClipboard;
